import ModelChip from './ModelChip';
export default ModelChip;
